// extracted by mini-css-extract-plugin
export default {"container":"LockContainer_container__khG2J","locked":"LockContainer_locked__Rz1I+","content":"LockContainer_content__3TVry","lockIcon":"LockContainer_lockIcon__cwzBj"};